import { Injectable } from '@angular/core';
import { UgcImage } from '@df/ugc-image/ugc-image';
import { UgcImageResource } from '@df/ugc-image/ugc-image.resource';
import take from 'lodash-es/take';

@Injectable({
    providedIn: 'root'
})
export class UgcImageService {
    constructor(private ugcImageResource: UgcImageResource) {}
    loadImages(
        ugcCategories?: number[],
        productSkus?: string[],
        limit = 20,
        nywItemRangeCodeNh?: number[],
        rooms?: string[]
    ): Promise<UgcImage[]> {
        return new Promise((resolve, reject) => {
            const filter: {
                sku?: {
                    $in: string[];
                };
                product_type?: {
                    $in: number[];
                };
                nyw_item_range_code_nh?: {
                    $in: number[];
                };
                room?: {
                    $in: string[];
                };
            } = {};
            if (productSkus?.length) {
                filter.sku = { $in: productSkus };
            }
            if (ugcCategories?.length) {
                filter.product_type = { $in: ugcCategories };
            }
            if (nywItemRangeCodeNh?.length) {
                filter.nyw_item_range_code_nh = { $in: nywItemRangeCodeNh };
            }
            if (rooms?.length) {
                filter.room = { $in: rooms };
            }
            this.ugcImageResource
                .find({ verbosity: 1, filter, limit, sort: { created_at: -1 } })
                .then(ugcImages => {
                    resolve(take(ugcImages, limit));
                })
                .catch(() => reject());
        });
    }
}
